import { render, staticRenderFns } from "./ManageTradeDesk.vue?vue&type=template&id=628bb422&scoped=true&"
import script from "./ManageTradeDesk.vue?vue&type=script&lang=js&"
export * from "./ManageTradeDesk.vue?vue&type=script&lang=js&"
import style0 from "./ManageTradeDesk.vue?vue&type=style&index=0&id=628bb422&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628bb422",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('628bb422')) {
      api.createRecord('628bb422', component.options)
    } else {
      api.reload('628bb422', component.options)
    }
    module.hot.accept("./ManageTradeDesk.vue?vue&type=template&id=628bb422&scoped=true&", function () {
      api.rerender('628bb422', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/transactions/forms/ManageTradeDesk.vue"
export default component.exports